export enum WarehouseLocalizationListItemAction {
  Edit,
  Remove,
}
